import React from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";

export default function ButtonBack() {
  let history = useHistory();

  return (
    <div>
      <IconButton
        component="span"
        color="inherit"
        onClick={() => history.goBack()}
      >
        <ArrowBackIcon fontSize="large" />
      </IconButton>
    </div>
  )
}
